import { Pastille, type TeinteDeStatut } from './Pastille';

/**
 * **Un statut : une pastille ET un mot.** Jamais l'un sans l'autre.
 *
 * « Une couleur porte un **niveau**, un mot porte une **identité**. » La pastille seule
 * dirait qu'il se passe quelque chose de grave sans dire quoi ; le mot seul perdrait le
 * niveau. **Et une couleur seule n'est pas lisible par qui ne la distingue pas** — la
 * pastille est donc `aria-hidden`, et c'est le mot que la synthèse vocale lit.
 */
type Props = {
  readonly teinte: TeinteDeStatut;
  readonly pleine?: boolean;
  readonly children: string;
};

export function Statut({ teinte, pleine = true, children }: Props) {
  return (
    <span className="inline-flex items-center gap-2 text-14 font-weight-700 text-statut-libelle">
      <Pastille teinte={teinte} pleine={pleine} />
      {children}
    </span>
  );
}
